export default async function findAllPost(){
    try {
        const response = await fetch('https://back-office-sqbb.fr/wp-json/wp/v2/posts?per_page=100&_embed=true&_sort=desc');
        return  await response.json();
    }catch (err){
        console.error(`BLOG SQBB => ERROR :: Récupération de tous les articles a echoué :: ${err}`)
    }
}